import { Prismic, PrismicLink, getDataFromLink } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { Img } from '../components/img/Img';
import { Podcast } from '../components/podcast/Podcast';
import { PodcastItem } from '../components/podcast/PodcastItem';

interface FeaturedPodcastsContainerField {
  podcast_link: Prismic.Link;
  podcast_duration: Prismic.RichText;
}

interface FeaturedPodcastsContainerProps {
  title: Prismic.RichText;
  description: Prismic.RichText;
  button_link: Prismic.Link;
  button_text: Prismic.RichText;
  fields: FeaturedPodcastsContainerField[];
}

export function FeaturedPodcastsContainer(
  props: FeaturedPodcastsContainerProps,
) {
  const { title, description, button_link, button_text, fields } = props;
  return (
    <Segment>
      <Podcast
        title={Prismic.text(title)}
        text={Prismic.text(description)}
        link={
          <PrismicLink value={button_link} title={button_text}>
            <a>{Prismic.text(button_text)}</a>
          </PrismicLink>
        }
      >
        {fields?.map(({ podcast_duration, podcast_link }, index) => {
          const linkdata = getDataFromLink(podcast_link);
          return (
            <PrismicLink
              key={`podcast-item-${index}`}
              value={podcast_link}
              title={linkdata.title ?? undefined}
            >
              <PodcastItem
                title={Prismic.text(linkdata.title)}
                image={
                  <Img
                    src={linkdata.image ?? undefined}
                    percentage={0.1}
                    ar="ar_1_1"
                  />
                }
                duration={Prismic.text(podcast_duration)}
              />
            </PrismicLink>
          );
        })}
      </Podcast>
    </Segment>
  );
}
